import { types } from "./types";
import ImportCSV from "./ImportCSV/ImportCSV";
import ImportJSON from "./ImportJSON/ImportJSON";
import ImportExcel from "./ImportExcel/ImportExcel";
import External from "./External/External";

function Actions(
  action,
  showAlert,
  variables,
  setOpenVariable,
  variableRender
) {
  switch (action.actionName) {
    case types.IMPORTCSV:
      return (
        <ImportCSV
          action={action}
          variables={variables}
          setOpenVariable={setOpenVariable}
          variableRender={variableRender}
        />
      );
    case types.IMPORTJSON:
      return (
        <ImportJSON
          action={action}
          variables={variables}
          setOpenVariable={setOpenVariable}
          variableRender={variableRender}
        />
      );
    case types.IMPORTEXCEL:
      return (
        <ImportExcel
          action={action}
          variables={variables}
          setOpenVariable={setOpenVariable}
          variableRender={variableRender}
        />
      );
    case types.EXTERNAL:
      return (
        <External
          action={action}
          variables={variables}
          setOpenVariable={setOpenVariable}
          variableRender={variableRender}
        />
      );
    default: break;
  }
}

export default Actions;
